import React, { useEffect, useRef, useState } from "react";
import { LaundryCompanyHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
// import TableGrid from "../components/Table";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainPopup from "../popup-containers/MainPopup";
// import download from "../image/download.png";
import toast, { Toaster } from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI, ImageAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import FileUpload from "../ReusableComponents/FileUpload";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import { isValidMobileNumber } from "../utils/validation";
import Loader from "../ReusableComponents/Loader"
import LaundryCompanyPopup from "../popup-containers/LaundryCompanyPopup";

var createdBy = sessionStorage.getItem("createdBy"); // user session
var mstClientId = sessionStorage.getItem("MstClientId");


const LaundryCompany = () => {
  const location = useLocation();
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const laundryCompanyRef = useRef(null);
  const addressRef = useRef(null);
  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const branchProjectRef = useRef(null);
  const pinCodeRef = useRef(null);
  const contactPersonRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const designationRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formFields, setformFields] = useState({
    LaundryCompanyId: "LCO",
    laundryCompany: "",
    address: "",
    country: "1",
    state: "",
    branchProject: "",
    pinCode: "",
    date: new Date(),
    fileUpload: "",
    contactPerson: "",
    designation: "",
  mobileNumber: "",
  email: "", 
  });

  const [formFieldsError, setformFieldsError] = useState({
    LaundryCompanyIdError: "",
    laundryCompanyError: "",
    addressError: "",
    countryError: "",
    stateError: "",
    branchProjectError: "",
    pinCodeError: "",
    dateError: "",
    branchProjectError: "",
    fileUploadError: "",
    contactPersonError: "",
    designationError: "",
    mobileNumberError: "",
    emailIdError: "",
  });
  useEffect(() => {
    const fetchData = async () => {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      setformFields({ ...formFields, date: formattedDate });
    };

    fetchData();
  }, []);
  const handleformFieldsChange = (value, name) => {
    //
    console.log("Values:", value, name);
    setformFields({
      ...formFields,
      [name]: value,
    });
  };

  const [MstLaundryCompanyId, setMstLaundryCompanyId] = useState("");

  const [companyData, setCompanyData] = useState({});

  const [addScreenTitle, setAddScreenTitle] = useState(false);

  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  // View details start

  const [rowIndex, setRowIndex] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitVisibleButton, setSubmitVisibleButton] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [popViewdata, setPopViewdata] = useState({});
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [companydata2, setCompanydata2] = useState({});

  // view details end

  const [bindLaundryCompanyDatas, setBindLaundryCompanyDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Set the initial items per page
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [bindCommoditiesDD, setBindCommoditiesDD] = useState([]);
useEffect(() => {
  const fetchData = async () => {
    try {
      setIsLoading(true);

      // Run multiple async functions in parallel for efficiency
      await Promise.all([
        binddrpCoutrydata(),
        binddrpstatedata(),
        binddrpMedicinesdrugsdata(),
        BindCompanyGridData(),
      ]);

    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchData();
}, []);

// Clean, async function separated for clarity
const BindCompanyGridData = async () => {
  try {
    const data = { mstClientId };
    const response = await BindPostAPI(data, "LaundryCompanyAPI/BindLaundryCompany");

    if (response?.data?.Table) {
      setBindLaundryCompanyDatas(response.data.Table);
      console.log("Laundry Companies:", response.data.Table);
    } else {
      console.warn("No company data found:", response);
    }
  } catch (error) {
    console.error("Error fetching company data:", error);
  }
};


  const binddrpCoutrydata = async () => {
    try {
      const bindCountrydatadrp = await BindAPI("CountryAPI/BindCountry");

      const countryList = bindCountrydatadrp?.data?.Table;

      if (Array.isArray(countryList) && countryList.length > 0) {
        const countryDD = countryList.map((m) => ({
          value: m.MstCountryId,
          label: m.CountryName,
        }));
        setCountryBindDD(countryDD);
      } else {
        setCountryBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };
  const binddrpstatedata = async () => {
    try {
      const bindStatedatadrp = await BindAPI("StateAPI/GetState/");
      if (bindStatedatadrp.data.Table.length > 0) {
        const stateDD = bindStatedatadrp.data.Table.map((m) => ({
          value: m.MstStateId,
          label: m.State,
        }));

        setStateBindDD(stateDD);
      } else {
        setStateBindDD([]);
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  const binddrpMedicinesdrugsdata = async () => {
    try {
      const bindMedicinesdrugsdatadrp = await BindAPI(
        "MasterDataAPI/BindAllMasterData"
      );

      console.log("Medicines:", bindMedicinesdrugsdatadrp.data);
      if (bindMedicinesdrugsdatadrp.data.Table10.length > 0) {
        const medicinesdrugsDD = bindMedicinesdrugsdatadrp.data.Table10.map(
          (m) => ({
            value: m.MstCommoditiesId,
            label: m.CommodityName_en,
          })
        );
        setBindCommoditiesDD(medicinesdrugsDD);
      } else {
        setBindCommoditiesDD([]);
      }
    } catch (error) {
      console.error("Error fetching Medicines Drugs data:", error);
    }
  };

  useEffect(() => {
    const getSelectedLocation = async () => {
      const locationResponse = await BindAPI("CityAPI/BindCity");
      setGetLocationDatas(locationResponse.data.Table);
      console.log("locationResponse", locationResponse);
    };
    getSelectedLocation();
  }, []);

  useEffect(() => {

    // Find the selected state in getLocationDatas
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == formFields.state // Replace with the desired MstStateId
    );
    console.log("stateSelectedValue", getLocationDatas, formFields);
    if (stateSelectedValue) {
      const branchProjectLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstCityId: item.MstCityId,
          City: item.City,
        }));
      const branchProjectSelected = branchProjectLabels.map((LC) => ({
        value: LC.MstCityId, // Replace with the appropriate value
        label: LC.City,
      }));
      setBranchProjectBindDD(branchProjectSelected);
    } else {
    }
  }, [formFields.state]);
  console.log("city selected", formFields.branchProject)

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    setformFields({ ...formFields, date: formattedDate });
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setSubmitVisibleButton(false);
    setIsLoading(false)
    clear();
  };
  const clear = () => {
    //Clear Company data
    BindCompanyGridData();
    setformFields({
      LaundryCompanyId: "LCO",
      laundryCompany: "",
      address: "",
      country: "1",
      state: "",
      branchProject: "",
      pinCode: "",
      date: "",
      fileUpload: "",
      contactPerson: "",
      designation: "",
      mobileNumber: "",
      email: "",
    });
    setformFieldsError({
      LaundryCompanyIdError: "",
      laundryCompanyError: "",
      addressError: "",
      countryError: "",
      stateError: "",
      branchProjectError: "",
      pinCodeError: "",
      dateError: "",
      fileUpload: "",
      contactPerson: "",
      designation: "",
      mobileNumber: "",
      Email: "",
    });

  };

  const handleFileUpload = (FileUpload) => {

    console.log("image", FileUpload);
    setformFields({
      ...formFields,
      fileUpload: FileUpload || "",
    });

    console.log(formFields);


    setformFieldsError({ ...formFieldsError, FileUploadError: "" });
  };


  const handleEdit = async (rowIndex) => {

    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(true);
    setAddScreenTitle(false);
    var companyDate = bindLaundryCompanyDatas[rowIndex].Date;
    const companyDatePart = companyDate.split("T")[0];
    setformFields({
      ...formFields,
      LaundryCompanyId: bindLaundryCompanyDatas[rowIndex].LaundryCompanyId,
      laundryCompany: bindLaundryCompanyDatas[rowIndex].LaundryCompany,
      address: bindLaundryCompanyDatas[rowIndex].Address,
      country: bindLaundryCompanyDatas[rowIndex].MstCountryId,
      state: bindLaundryCompanyDatas[rowIndex].MstStateId,
      branchProject: bindLaundryCompanyDatas[rowIndex].MstCityId,
      pinCode: bindLaundryCompanyDatas[rowIndex].Pincode,

      date: companyDatePart,
      fileUpload: bindLaundryCompanyDatas[rowIndex].FileUpload,
      contactPerson:
        bindLaundryCompanyDatas[rowIndex].ContactPerson,
      designation: bindLaundryCompanyDatas[rowIndex].Designation,
      mobileNumber: bindLaundryCompanyDatas[rowIndex].MobileNumber,
      email: bindLaundryCompanyDatas[rowIndex].EmailId,
    });

    setMstLaundryCompanyId(bindLaundryCompanyDatas[rowIndex].MstLaundryCompanyId);

  };

  const handleLaundryCompany = (rowIndex, flag) => {


    setpopUpOpen(true);
    // setRowIndex(rowIndex);

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    setCompanyData(bindLaundryCompanyDatas[rowIndex]);
    const CountryrowData = bindLaundryCompanyDatas[rowIndex];
    const CountryInfo = countryBindDD.find(
      (ST) => ST.value === CountryrowData.MstCountryId
    );
    const resultCountry = {
      value: CountryrowData.MstCountryId,
      label: CountryInfo ? CountryInfo.label : "",
    };
    const StaterowData = bindLaundryCompanyDatas[rowIndex];
    const StateInfo = stateBindDD.find(
      (ST) => ST.value === StaterowData.MstStateId
    );
    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "DefaultStateLabel",
    };
    const locationrowData = bindLaundryCompanyDatas[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstLocationId
    );
    const ResultLocation = {
      value: locationrowData.MstCityId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };
    const medicinesDrugsData = bindLaundryCompanyDatas[rowIndex];
    const medicinesDrugsInfo = bindCommoditiesDD.find(
      (ST) => ST.value === medicinesDrugsData.CompanyCommodities
    );
    const resultmedicinesDrugs = {
      value: medicinesDrugsData.CompanyCommodities,
      label: medicinesDrugsInfo ? medicinesDrugsInfo.label : "",
    };
    var companyDate = bindLaundryCompanyDatas[rowIndex].Date;
    const companyDatePart = companyDate.split("T")[0];

    const Companydata2 = [
      resultCountry,
      resultState,
      ResultLocation,
      resultmedicinesDrugs,
      companyDatePart,
    ];

    setCompanydata2(Companydata2);
  };

  const [branchProjectBindDD, setBranchProjectBindDD] = useState([]);
  const [stateBindDD, setStateBindDD] = useState([]);
  const [countryBindDD, setCountryBindDD] = useState([
  ]);
  const createdBy = sessionStorage.getItem("createdBy");
  const mstClientId = sessionStorage.getItem("MstClientId");

  const validate = (flag) => {
    // Initialize an object to store validation errors for each field
    const errors = {};
  };
  const handleSubmit = async (items, flag) => {
    

    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      const isFormError = {
        ...formFieldsError,

        laundryCompanyError:
          formFields.laundryCompany?.length > 0
            ? /^[A-Za-z.' ]+$/.test(formFields.laundryCompany)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Company Name",

        addressError: formFields.address.length > 0 ? "" : "Enter Address",
        countryError: formFields.country ? "" : "Select Country",
        stateError: formFields.state ? "" : "Select State",
        branchProjectError: formFields.branchProject ? "" : "Select City",
        pinCodeError: formFields.pinCode ? "" : "Enter Pin Code",

        contactPersonError:
          formFields.contactPerson.length > 0
            ? /^[A-Za-z ]+$/.test(formFields.contactPerson)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Contact Person",

        mobileNumberError:
          formFields.mobileNumber.length > 0
            ? /^\d{10,11}$/.test(formFields.mobileNumber)
              ? ""
              : "Enter a valid Contact Number"
            : "Enter Contact Number",
        designationError:
          formFields.designation.length > 0
            ? /^[A-Za-z.' ]+$/.test(formFields.designation)
              ? ""
              : "Only Alphabet and space allowed"
            : "Enter Designation",
      };
      setformFieldsError(isFormError);
      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );
      if (isFormValid) {
        setSubmitBtnDisabled(true);


        const companyPayload = [
          {
            MstLaundryCompanyId: MstLaundryCompanyId ? MstLaundryCompanyId : 0,
            mstClientId: mstClientId,
            LaundryCompany: formFields.laundryCompany,
            LaundryCompanyId: formFields.LaundryCompanyId,
            MstCountryId: formFields.country,
            MstStateId: formFields.state,
            MstCityId: formFields.branchProject,
            Address: formFields.address,
            Pincode: formFields.pinCode,
            Date: formFields.date,
            FileUpload: formFields.fileUpload? formFields.fileUpload : "" ,
            ContactPerson: formFields.contactPerson,
            Designation: formFields.designation,
            MobileNumber: formFields.mobileNumber,
            EmailId: formFields.email,
            createdby: createdBy,
            flag: flag,
          },
        ];

        const response = await IUDAPI(
          companyPayload,
          "LaundryCompanyAPI/IUDLaundryCompany"
        );

        if (flag == 1) {
          // Submit

          if (response.data.Table[0].Result === "S") {
            toast.success("Company added successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setSubmitVisibleButton(true);
            setformFields({
              ...formFields,
              LaundryCompanyId: response.data.Table[0].LaundryCompanyId,
            });
            setTimeout(cancel, 10000);
          } else {
            toast.error("Failed to add Company data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Company updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update Company data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsOpen(true);
        if (isFormError.laundryCompanyError && laundryCompanyRef.current) {
          laundryCompanyRef.current.focus();
        } else if (isFormError.addressError && addressRef.current) {
          addressRef.current.focus();
        } else if (isFormError.countryError && countryRef.current) {
          countryRef.current.focus();
        } else if (isFormError.stateError && stateRef.current) {
          stateRef.current.focus();
        } else if (isFormError.branchProjectError && branchProjectRef.current) {
          branchProjectRef.current.focus();
        } else if (isFormError.pinCodeError && pinCodeRef.current) {
          pinCodeRef.current.focus();
        } else if (isFormError.contactPersonError && contactPersonRef.current) {
          contactPersonRef.current.focus();
        } else if (
          isFormError.designationError &&
          designationRef.current
        ) {
          designationRef.current.focus();
        } else if (isFormError.mobileNumberError && mobileNumberRef.current) {
          mobileNumberRef.current.focus();
        }

      }
    } else {
      const data = {
        MstLaundryCompanyId: bindLaundryCompanyDatas[items].MstLaundryCompanyId,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "LaundryCompanyAPI/IUDLaundryCompany");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success(
            "Company data deleted successfully 🗑️",
            5000,
            cancel()
          );
        } else {
          toast.error("Failed to delete Company data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Company data Inactivated successfully! 👍",
            5000,

            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to Inactivate Company data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success(
            "Company data activated successfully! 👍",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to activate Company data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
    setIsLoading(false)
  };
  useEffect(() => {
    if (location.pathname == "/laundryCompany") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location]);


  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Laundry Companies"
          header={LaundryCompanyHeader}
          records={bindLaundryCompanyDatas}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleLaundryCompany}
          showAdd={showAdd}
        />

      )}

      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Laundry Companies"
            />
            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div class={mainTable.labelBold}>Company Details</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class="grid gap-4 mb-6 md:grid-cols-3">
                    <InputText
                      inputType={"text"}
                      title=" Laundry Companies Id"
                      name="LaundryCompaniesId"
                      maxLength={20}
                      classStar={"text-red-500"}
                      content={formFields.LaundryCompanyId}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          laundryCompanyId: e.target.value,
                        })
                      }
                      disabled={true}
                    />

                    <InputText
                      ref={laundryCompanyRef}
                      inputType="text"
                      title="Company Name"
                      name="laundryCompany"
                      classStar={"text-red-500"}
                      maxLength={100}
                      content={formFields.laundryCompany}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          laundryCompany: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setformFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          laundryCompanyError:
                            formFields.laundryCompany
                              // &&
                              // formFields.laundryCompany.length > 0
                              ? /^[A-Za-z.' ]+$/.test(
                                formFields.laundryCompany
                              )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Company Name",
                        }));
                      }}
                      errorMessage={formFieldsError.laundryCompanyError}
                    />


                    <InputText
                      ref={addressRef}
                      inputType="text"
                      title="Address"
                      maxLength={500}
                      name="address"
                      classStar={"text-red-500"}
                      content={formFields.address}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          address: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setformFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          addressError:
                            formFields.address &&
                              formFields.address.length > 0
                              ? /^[A-Za-z0-9, -/]+$/.test(
                                formFields.address
                              )
                                ? ""
                                : "Only Alphabets, numbers, commas, hyphens, and spaces allowed"
                              : "Enter Address",
                        }));
                      }}
                      errorMessage={formFieldsError.addressError}
                    />
                    <AutoDropDown
                      title="Country"
                      ref={countryRef}
                      options={countryBindDD}
                      placeholder="Select"
                      name="country"
                      selectedOption={countryBindDD.find(
                        (x) => x.value == formFields.country
                      )}
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleformFieldsChange(value.value, e.name);

                      }}
                      controlFuncBlur={() => {
                        setformFieldsError(() => ({
                          ...formFieldsError,
                          countryError: formFields.country
                            ? ""
                            : "Select Country",
                        }));
                      }}
                      errorMessage={formFieldsError.countryError}
                    />


                    <AutoDropDown
                      title="State"
                      ref={stateRef}
                      options={stateBindDD}
                      placeholder="Select"
                      name="state"
                      selectedOption={stateBindDD.find(
                        (x) => x.value == formFields.state
                      )}
                      Class="p-0"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleformFieldsChange(value.value, e.name);
                        setformFields({
                          ...formFields,
                          state: value.value,
                          branchProject: "",
                        });
                        setformFieldsError({
                          ...formFieldsError,
                          stateError: value ? "" : "Select State",
                        });

                      }}
                      controlFuncBlur={() => {
                        setformFieldsError(() => ({
                          ...formFieldsError,
                          stateError: formFields.state
                            ? ""
                            : "Select State",
                        }));
                      }}
                      errorMessage={formFieldsError.stateError}

                    />


                    <AutoDropDown
                      title="City"
                      ref={branchProjectRef}
                      options={branchProjectBindDD}
                      placeholder="Select"
                      name="branchProject"
                      selectedOption={
                        formFields.branchProject
                          ? branchProjectBindDD.find(
                            (x) => x.value == formFields.branchProject
                          )
                          : ""
                      }
                      Class="custom-class"
                      // tabIndex="1"
                      classStar="text-red-500"
                      controlFunc={(value, e) => {
                        handleformFieldsChange(value.value, e.name);

                      }}
                      controlFuncBlur={() => {
                        setformFieldsError(() => ({
                          ...formFieldsError,
                          branchProjectError: formFields.branchProject
                            ? ""
                            : "Select City",
                        }));
                      }}
                      errorMessage={formFieldsError.branchProjectError}

                    />


                    <InputText
                      ref={pinCodeRef}
                      inputType="text"
                      title="Pin Code"
                      name="pinCode"
                      classStar="text-red-500"
                      maxLength={6}
                      content={formFields.pinCode}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          pinCode: e.target.value,
                        })
                      }
                      controlFuncBlur={() => {
                        setformFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          pinCodeError:
                            formFields.pinCode &&
                              formFields.pinCode.length > 0
                              ? /^[\d\s]+$/.test(formFields.pinCode)
                                ? ""
                                : "Only numbers allowed"
                              : "Enter Pin Code",
                        }));
                      }}
                      errorMessage={formFieldsError.pinCodeError}
                    />

                    <InputText
                      inputType="date"
                      title="Date"
                      classStar="text-red-500"
                      name="date"
                      content={formFields.date}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          date: e.target.value,
                        })
                      }
                    />
                    <div></div>

                  </div>

                  {/* <FileUpload
                    title="Upload File"
                    // classStar="text-red-500"
                    apiCall="LaundryCompanyAPI/LaundryCompanyImageUpload"
                    modalName="LaundryCompanyImages"
                    name="FileUpload"
                    disabledBtn={updateScreenTitle}
                    FileUpload={formFields.fileUpload}
                    FileUploadData={handleFileUpload}
                    imageUploadedError={formFieldsError.fileUploadError}
                    limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                    MAX_FILE_SIZE_MB={2}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  /> */}
<FileUpload
                                    title="Upload File"
                                    // classStar="text-red-500"
                                    apiCall="LaundryCompanyAPI/LaundryCompanyImageUpload"
                                    modalName="LaundryCompanyImages"
                                    name="FileUpload"
                                    disabledBtn={updateScreenTitle}
                                    showImage={formFields.fileUpload}
                                    showImageData={handleFileUpload}
                                    imageUploadedError={formFieldsError.fileUpload}
                                    limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                                    MAX_FILE_SIZE_MB={2}
                                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                                />

                  {/* <FileUpload
                    title="Upload File"
                    classStar="text-red-500"
                    apiCall="LaundryCompanyAPI/LaundryCompanyImageUpload"
                    modalName="LaundryCompanyImages"
                    name="FileUpload"
                    disabledBtn={updateScreenTitle}
                    FileUpload={formFields.FileUpload}
                    FileUploadData={handleFileUpload}
                    imageUploadedError={formFieldsError.FileUploadError}
                    limitMassage="Image size limit: 2MB. Accepted Image types: jpg, png, jpeg."
                    MAX_FILE_SIZE_MB={2}
                    ALLOWED_FORMATS={["image/jpeg", "image/jpg", "image/png"]}
                  /> */}


                  <div class={mainTable.labelBold}>Contact Info</div>

                  <hr class={mainTable.horizontalLine}></hr>

                  <div class="grid gap-4 mb-6 md:grid-cols-3">
                    <InputText
                      ref={contactPersonRef}
                      inputType="text"
                      title="Contact Person"
                      name="contactPerson"
                      classStar="text-red-500"
                      maxLength={100}
                      content={formFields.contactPerson}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          contactPerson: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setformFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          contactPersonError:
                            formFields.contactPerson &&
                              formFields.contactPerson.length > 0
                              ? /^[A-Za-z ]+$/.test(
                                formFields.contactPerson
                              )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Contact Person",
                        }));
                      }}
                      errorMessage={formFieldsError.contactPersonError}
                    />


                    <InputText
                      ref={designationRef}
                      inputType="text"
                      title="Designation"
                      name="designation"
                      classStar={"text-red-500"}
                      maxLength={50}
                      content={formFields.designation}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          designation: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setformFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          designationError:
                            formFields.designation &&
                              formFields.designation.length > 0
                              ? /^[A-Za-z ]+$/.test(
                                formFields.designation
                              )
                                ? ""
                                : "Only Alphabet and space allowed"
                              : "Enter Designation",
                        }));
                      }}
                      errorMessage={
                        formFieldsError.designationError
                      }
                    />


                    <InputText
                      ref={mobileNumberRef}
                      inputType="numbers"
                      title="Mobile Number"
                      name="mobileNumber"
                      classStar="text-red-500"
                      maxLength={11}
                      content={formFields.mobileNumber}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          mobileNumber: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setformFieldsError((formFieldsError) => ({
                          ...formFieldsError,
                          mobileNumberError:
                            formFields.mobileNumber &&
                              formFields.mobileNumber.length > 0
                              ? /^\d{10,11}$/.test(formFields.mobileNumber)
                                ? ""
                                : "Enter a valid Contact Number"
                              : "Enter Contact Number",
                        }));
                      }}
                      errorMessage={formFieldsError.mobileNumberError}
                    />


                    <InputText
                      inputType="text"
                      title="Email Id"
                      name="email"
                      // classStar={"text-red-500"}
                      content={formFields.email}
                      controlFunc={(e) =>
                        setformFields({
                          ...formFields,
                          email: e.target.value,
                        })
                      }
                    />

                  </div>
                </form>


                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled || isLoading}
                />
                {submitVisibleButton && (
                  <div className="border p-2 flex flex-col items-center justify-center ">
                    <label className="flex gap-1  mb-2 text-sm font-medium text-neutral-700 ">
                      LaundryCompany Id :
                      <span className=" mb-2 text-sm font-bold text-neutral-700 ">
                        {formFields.LaundryCompanyId}
                      </span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="LaundryCompany"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <LaundryCompanyPopup data={companyData} data1={companydata2} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />

      </MainPopup>
    </MainLayout>
  );
};

export default LaundryCompany;